import React from "react";
import ServicesCard from "./ServicesCard";
// services image
import service1_Img from "../../assets/service1_Img.jpg";
import service2_Img from "../../assets/service2_Img.jpg";
import service3_Img from "../../assets/service3_Img.jpg";
import service4_Img from "../../assets/service4_Img.jpg";
import service5_Img from "../../assets/service5_Img.jpg";

import "animate.css";

const OurServices = () => {
  return (
    <div className="bg-white">
      <div className="relative items-center content-center text-center">
        <div className="py-2 m-auto text-2xl font-body font-semibold text-center text-black capitalize md:text-3xl lg:text-4xl pb-7 pt-16 sm:pt-10 md:pt-20">
          Our <span className="font-body text-secondary"> Services </span>
        </div>

        {/* Services cards */}
        {/* --------------------------------- MOBILE VIEW START ----------------------------------- */}
        <div className="px-3 transform translate-x-1 translate-y-2 md:hidden mt-24 sm:mt-24">
          <ServicesCard
            // bgcolor={`bg-gradient-to-b from-[#A760FF] to-[#ab04f3]`}
            bgcolor={
              "bg-white shadow-xl shadow-black-900 rounded-lg border-[1px] border-gray-300"
            }
            heading="Airport Transfers"
            paragraph="We service 350+ airports globally. All our transfers include meet and greet. Now travel in style, wherever you are going."
            image={service1_Img}
            imagemeta="Airport Transfers"
          />
          <ServicesCard
            // bgcolor={`bg-gradient-to-b from-[#AF113B] to-[#C0312C]`}
            bgcolor={
              "bg-white shadow-xl shadow-black-900 rounded-lg border-[1px] border-gray-300"
            }
            heading="VIP Assistance"
            paragraph="With Our Fast Track VIP Service, Be greeted by our representative at the aerobridge. From baggage handling, lounge stays, fast track immigration channel; experience hassle-free and seamless end to end airport experience."
            image={service2_Img}
            imagemeta="VIP Assistance"
          />
          <ServicesCard
            // bgcolor={`bg-gradient-to-b from-[#FFB200] to-[#C66000]`}
            bgcolor={
              "bg-white shadow-xl shadow-black-900 rounded-lg border-[1px] border-gray-300"
            }
            heading="Private Chauffeurs"
            paragraph="Experience our professional door to door service at an affordable price. Reserve your very own chauffeur service here and let us take care of the rest."
            image={service3_Img}
            imagemeta="Private Chauffeurs"
          />
          <ServicesCard
            // bgcolor={`bg-gradient-to-b from-[#006DFF] to-[#09265C]`}
            bgcolor={
              "bg-white shadow-xl shadow-black-900 rounded-lg border-[1px] border-gray-300"
            }
            heading="Events"
            paragraph="Be it a Business event, Sports event or Family Event, we are a one-stop-shop for all your transportation needs ensuring your peace of mind."
            image={service4_Img}
            imagemeta="Events"
          />
          <ServicesCard
            // bgcolor={`bg-gradient-to-b from-[#01AEC5] to-[#05343A]`}
            bgcolor={
              "bg-white shadow-xl shadow-black-900 rounded-lg border-[1px] border-gray-300"
            }
            heading="Corporate"
            paragraph="Now travel in comfort, style & arrive on time for meetings or events. You can choose precisely the right car to fit with your company ethos."
            image={service5_Img}
            imagemeta="Corporate"
          />
        </div>

        {/* --------------------------- WEB VIEW medium screen ---------------------------------- */}
        <div className="hidden pt-10 md:pt-0 lg:hidden md:flex md:flex-wrap">
          <div className="grid grid-cols-2 px-16 md:px-6 gap-x-2">
            <ServicesCard
              // bgcolor={`bg-gradient-to-b from-[#A760FF] to-[#ab04f3]`}
              bgcolor={
                "bg-white shadow-xl shadow-black-900 rounded-lg border-[1px] border-gray-300"
              }
              heading="Airport Transfers"
              paragraph="We service 350+ airports globally. All our transfers include meet and greet. Now travel in style, wherever you are going."
              image={service1_Img}
              imagemeta="Airport Transfers"
            />
            <ServicesCard
              // bgcolor={`bg-gradient-to-b from-[#FF0045] to-[#2e0b3b]`}
              bgcolor={
                "bg-white shadow-xl shadow-black-900 rounded-lg border-[1px] border-gray-300"
              }
              heading="VIP Assistance"
              paragraph="With Our Fast Track VIP Service, Be greeted by our representative at the aerobridge. From baggage handling, lounge stays, fast track immigration channel; experience hassle-free and seamless end to end airport experience."
              image={service2_Img}
              imagemeta="VIP Assistance"
            />
          </div>
          <div className="px-52">
            <ServicesCard
              // bgcolor={`bg-gradient-to-b from-[#E8A137] to-[#442C07]`}
              bgcolor={
                "bg-white shadow-xl shadow-black-900 rounded-lg border-[1px] border-gray-300"
              }
              heading="Private Chauffeurs"
              paragraph="Experience our professional door to door service at an affordable price. Reserve your very own chauffeur service here and let us take care of the rest."
              image={service3_Img}
              imagemeta="Private Chauffeurs"
            />
          </div>
          <div className="flex px-16 md:px-6">
            <ServicesCard
              // bgcolor={`bg-gradient-to-b from-[#006DFF] to-[#09265C]`}
              bgcolor={
                "bg-white shadow-xl shadow-black-900 rounded-lg border-[1px] border-gray-300"
              }
              heading="Events"
              paragraph="Be it a Business event, Sports event or Family Event, we are a one-stop-shop for all your transportation needs ensuring your peace of mind."
              image={service4_Img}
              imagemeta="Events"
            />
            <ServicesCard
              // bgcolor={`bg-gradient-to-b from-[#01AEC5] to-[#05343A]`}
              bgcolor={
                "bg-white shadow-xl shadow-black-900 rounded-lg border-[1px] border-gray-300"
              }
              heading="Corporate"
              paragraph="Now travel in comfort, style & arrive on time for meetings or events. You can choose precisely the right car to fit with your company ethos."
              image={service5_Img}
              imagemeta="Corporate"
            />
          </div>
        </div>

        {/* web view large screen */}
        <div className="hidden md:hidden lg:inline ">
          <div className="grid content-center grid-cols-3 py-16 lg:py-32 mx-auto px-28 lg:px-5 xl:px-24 2xl:px-20 max-w-screen-2xl animate__animated ">
            <ServicesCard
              // bgcolor={`bg-gradient-to-b from-[#A760FF] to-[#4C046A]`}
              bgcolor={
                "bg-white/20 shadow-xl shadow-black-900 rounded-lg border-[1px] border-gray-300"
              }
              heading="Airport Transfers"
              paragraph="We service 350+ airports globally. All our transfers include meet and greet. Now travel in style, wherever you are going."
              image={service1_Img}
              imagemeta="Airport Transfers"
            />
            <ServicesCard
              // bgcolor={`bg-gradient-to-b from-[#AF113B] to-[#53100E]`}
              bgcolor={
                "bg-white shadow-xl shadow-black-900 rounded-lg border-[1px] border-gray-300"
              }
              heading="VIP Assistance"
              paragraph="With Our Fast Track VIP Service, Be greeted by our representative at the aerobridge. From baggage handling, lounge stays, fast track immigration channel; experience hassle-free and seamless end to end airport experience."
              image={service2_Img}
              imagemeta="VIP Assistance"
            />
            <ServicesCard
              // bgcolor={`bg-gradient-to-b from-[#FFB200] to-[#7C4008]`}
              bgcolor={
                "bg-white shadow-xl shadow-black-900 rounded-lg  border-[1px] border-gray-300"
              }
              heading="Private Chauffeurs"
              paragraph="Experience our professional door to door service at an affordable price. Reserve your very own chauffeur service here and let us take care of the rest."
              image={service3_Img}
              imagemeta="Private Chauffeurs"
            />
          </div>
          <div className="flex items-center content-center py-2 mx-auto max-w-screen-2xl px-72 lg:px-10 xl:px-72">
            <ServicesCard
              // bgcolor={`bg-gradient-to-b from-[#006DFF] to-[#09265C]`}
              bgcolor={
                "bg-white shadow-xl shadow-black-900 rounded-lg border-[1px] border-gray-300"
              }
              heading="Events"
              paragraph="Be it a Business event, Sports event or Family Event, we are a one-stop-shop for all your transportation needs ensuring your peace of mind."
              image={service4_Img}
              imagemeta="Events"
            />
            <ServicesCard
              // bgcolor={`bg-gradient-to-b from-[#01AEC5] to-[#05343A]`}
              bgcolor={
                "bg-white shadow-xl shadow-black-900 rounded-lg border-[1px] border-gray-300"
              }
              heading="Corporate"
              paragraph="Now travel in comfort, style & arrive on time for meetings or events. You can choose precisely the right car to fit with your company ethos."
              image={service5_Img}
              imagemeta="Corporate"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurServices;
